<div class="loader centralize">
    <h4>No se encontraron resultados</h4>
    <br> <br>
    <img
      class="imgClass"
      alt="No se encontraron resultados"
      src="assets/icons/il-networking.svg"
    />
  </div>
